export enum EduTradingEconomicCalendarPeriod {

    Today = "today",
    TodayUpcoming = "today-upcoming",
    Tomorrow = "tomorrow",
    ThisWeek = "this-week",
    NextWeek = "next-week",
}
